export default __webpack_public_path__ + "static/media/asw338lm.ac036acf.svg";